/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:calc(100% - 70px);display:block;position:absolute;width:100%}#main-content[_ngcontent-%COMP%]{min-height:calc(100% - 261px)}#spinner[_ngcontent-%COMP%]{height:100%;width:100%;position:fixed;top:0;left:0;z-index:10000001;background:#f9f9f9}#spinner[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{position:absolute;height:100px;width:100px;top:50%;left:50%;margin-left:-50px;margin-top:-50px;background-size:100%}"];
export { styles as styles };
